module.exports = __webpack_public_path__ + "media/images/portal/main-graf-d8833959310142f63f55a245290de9b7.png";